import TemplateView from '../TemplateView'

export default class SimpleTwoOptionsMenu extends TemplateView {
    constructor({
        additionalClass = '',
        onFirstOptionSelected = () => {},
        onSecondOptionSelected = () => {},
    } = {}) {
        super()

        this.params = {
            additionalClass,
        }

        this.callbacks = {
            onFirstOptionSelected,
            onSecondOptionSelected,
        }

        this.state = {
            firstTitle: '',
            secondTitle: '',
        }

        this.onStatePropertyChanged('firstTitle', (firstTitle) => {
            this.$firstTitle.text(firstTitle)
        })
        this.onStatePropertyChanged('secondTitle', (secondTitle) => this.$secondTitle.text(secondTitle))
    }

    templateHtml() {
        return "<div class='components_simpleTwoOptionsMenu <%-additionalClass%>'>" +
               "  <div class='firstOption'>" +
               "    <div class='icon'></div>" +
               "    <div class='title'></div>" +
               "  </div>" +
               "  <div class='secondOption'>" +
               "    <div class='icon'></div>" +
               "    <div class='title'></div>" +
               "  </div>" +
               "</div>"
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }

    afterRender() {
        this.$firstTitle = this.find('.firstOption .title')
        this.$secondTitle = this.find('.secondOption .title')

        this.find('.firstOption').click((e) => {
            e.stopPropagation()
            this.callbacks.onFirstOptionSelected()
        })
        this.find('.secondOption').click((e) => {
            e.stopPropagation()
            this.callbacks.onSecondOptionSelected()
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/components/SimpleTwoOptionsMenu.js